import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios";
import { toast } from "react-toastify";
import Swal from "sweetalert2";

export interface CustomAxiosRequestConfig<D = any>
  extends AxiosRequestConfig<D> {
  showToast?: boolean;
}

export class ServerClient {
  private static _instance: ServerClient;

  public axiosInstance: AxiosInstance;

  private constructor() {
    this.axiosInstance = axios.create({
      baseURL: process.env.REACT_APP_BASE_URL,
      timeout: 10000,
      headers: {
        post: {
          "Content-Type": "application/json",
        },
        common: {
          Authorization: localStorage.getItem("token"),
        },
      },
    });
    this.axiosInstance.interceptors.response.use(
      (response) => {
        const res: AxiosResponse = response;
        if ((res.config as CustomAxiosRequestConfig).showToast !== false) {
          toast.success(res.data.result.message);
        }
        return Promise.resolve(res);
      },
      (error) => {
        if (
          error?.response?.status === 401 ||
          error?.response?.status === 403
        ) {
          window.location.href = `/login?return-to=${window.location.pathname}`;
          localStorage.clear();
          localStorage.removeItem("isExpert");
          localStorage.removeItem("expertId");

          const errorMessage = error?.response?.data?.errors[0]?.message;
          toast.error(errorMessage);
        } else if (axios.AxiosError.ETIMEDOUT === error.code) {
          this._alertUser(
            "عدم دریافت پاسخ",
            "پاسخی از سرور اگرویار دریافت نشد"
          );
        } else if (axios.AxiosError.ERR_NETWORK === error.code) {
          this._alertUser(
            "عدم اتصال به اینترنت",
            "اتصال اینترنت برقرار نمی باشد لطفا وضعیت اتصال اینترنت دستگاه خود را بررسی کنید"
          );
        } else {
          const errorMessage = error?.response?.data?.errors[0]?.message;
          toast.error(errorMessage);
        }
      }
    );
  }

  public static Instance() {
    return this._instance || (this._instance = new this());
  }

  _alertUser(title: string, text: string) {
    Swal.fire({
      icon: "error",
      title,
      text,
      confirmButtonText: "تلاش مجدد",
    }).then((res) => {
      if (res.isConfirmed) {
        window.location.reload();
      }
    });
  }
}
